import styled from 'styled-components';

const Textarea = styled.textarea`
  display: block;
  width: 100%;
  height: 100%;
  padding: 15px;
  border: 1px solid #d1d1d1;
  outline: none;
  box-sizing: border-box;
  resize: none;
`

export default Textarea;


// WEBPACK FOOTER //
// ./client/components/Styled/Textarea/index.js